module.exports = __webpack_public_path__ + "static/media/stardate.9ff82cc6.png";